import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

export const SuccessMessageStyled = styled(Typography)`
  margin-top: 0.375rem;
`;

export const DoneIconWrapStyled = styled.div`
  animation: 0.2s linear 0.3s both spring;

  @keyframes spring {
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
